import React, {useEffect, useRef, useState} from 'react'
import '../../../css/web/UserModalRenew.css'
import useTheme from '../layoutscommon/DarkModeStorage'
import '../../../css/web/UserAddrBook.css';
import {GrClose} from "react-icons/gr";
import commonClose from '../../../assets/img/commonClose.png'
import chatFileImg from '../../../assets/img/chatFolderImg.png'
import chatVideoImg from '../../../assets/img/chatVideoImg.png'
import chatPdfImg from '../../../assets/img/chatPdfImg.png'
import chatExcelImg from '../../../assets/img/chatExcelImg.png'
import fileExchange from '../../../assets/img/fileExchange.png'
import commonZip from '../../../assets/img/commonZip.png'
import {useTranslation} from "react-i18next";
import MsgCheckModal from "./MsgCheckModal";




function ChatFileUpload({showChatFileClose, selectedFile, selectedFileUrl, saveChatFile,
                            chatFileModifySt, chatFileModifyFalseFn, messageToModify, chatFileModify,
                            nonSelectedFile, nonShowChatFileClose, nonSelectedFileUrl, saveNonChatFile, nonShowChatFile,
                            nonChatFileModifySt, nonChatFileModifyFalseFn, nonChatFileModify, nonMessageToModify}) {

    const { t } = useTranslation();
    const [theme] = useTheme();

    const [selectedModifyFile, setSelectedModifyFile] = useState(selectedFile)
    const [selectedModifyFileUrl, setSelectedModifyFileUrl] = useState('');

    const [nonSelectedModifyFile, setNonSelectedModifyFile] = useState(nonSelectedFile)
    const [nonSelectedModifyFileUrl, setNonSelectedModifyFileUrl] = useState('');

    const [modifyFile, setModifyFile] = useState('');
    const [nonModifyFile, setNonModifyFile] = useState('');

    useEffect(()=> {
        if (chatFileModifySt) {
            setModifyFile("https://toeloperfile.s3.ap-northeast-2.amazonaws.com/ordChatMessage/" + messageToModify.chatKey)
        } else if (nonChatFileModifySt) {
            setNonModifyFile("https://toeloperfile.s3.ap-northeast-2.amazonaws.com/nUserChatMsg/" + nonMessageToModify.chatKey)
        }
    }, [])

    const [fileSizeOverSt, setFileSizeOverSt] = useState(false);
    const closeFileSizeOverSt = (() => {
        setFileSizeOverSt(false);
    })

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        const maxSize = 128 * 1024 * 1024;
        if (file.size > maxSize) {
            setFileSizeOverSt(true);
            return;
        }
        if (chatFileModifySt) {
            setSelectedModifyFile(file);
            setSelectedModifyFileUrl(URL.createObjectURL(file));
        } else if (nonChatFileModifySt) {
            setNonSelectedModifyFile(file);
            setNonSelectedModifyFileUrl(URL.createObjectURL(file));
        }
    };

    const renderFilePreview = () => {
        if (selectedModifyFile) {
            return renderChangeFilePreview();
        } else if (nonSelectedModifyFile) {
            return nonRenderChangeFilePreview();
        }
        else if (selectedFile) {
            return renderUploadFilePreview();
        }
        else if (modifyFile) {
            return renderModifyFilePreview();
        }
        else if (!nonSelectedModifyFile && nonModifyFile) {
            return nonRenderModifyFilePreview();
        }
        else if (nonSelectedFile) {
            return nonRenderUploadFilePreview();
        }
        else {
            return null;
        }
    };

    // 사용자(주문서/비회원) new 파일업로드 통합
    // const renderUploadFilePreview = () => {
    //     if (!selectedFile) {
    //         return null;
    //     }
    //     if (selectedFile) {
    //         if (selectedFile.type.startsWith('image/')) {
    //             return <img style={{width: "90%", height: "90%"}} alt="" src={selectedFileUrl}/>;
    //         }
    //
    //         if (selectedFile.type.startsWith('video/')) {
    //             return <img style={{width: "90%", height: "90%"}} alt="" src={chatVideoImg}/>;
    //         }
    //         if (selectedFile.type.startsWith('application/pdf') || selectedFile.type.endsWith('/pdf')) {
    //             return <img style={{width: "90%", height: "90%"}} alt="" src={chatPdfImg}/>;
    //         }
    //         if (selectedFile.type.endsWith('zip-compressed')) {
    //             return <img style={{width: "90%", height: "90%"}} alt="" src={commonZip}/>;
    //         }
    //
    //         if (selectedFile) {
    //             let fileExtension = selectedFile.name.split('.').pop().toLowerCase();
    //
    //             if (['xlsx', 'xls', 'xlsm', 'xlsb', 'xltx'].includes(fileExtension)) {
    //                 return <img style={{width: "90%", height: "90%"}} alt="" src={chatExcelImg}/>;
    //             }
    //         } else return <img style={{width: "90%", height: "90%"}} alt="" src={chatFileImg}/>;
    //     }
    // };

    // 사용자(주문서/비회원) new 파일업로드 통합
    const renderUploadFilePreview = () => {
        if (!selectedFile) return null;

        const extension = (selectedFile.name || '').split('.').pop()?.toLowerCase();
        const mime = selectedFile.type || '';

        if (
            ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'heic', 'heif', 'svg', 'tiff', 'tif'].includes(extension) ||
            mime.startsWith('image/')
        ) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={selectedFileUrl} />;
        }

        if (
            ['mp4', 'mov', 'avi', 'mkv', 'webm', '3gp', 'm4v', 'mpg', 'mpeg', 'm2v', 'flv', 'swf'].includes(extension) ||
            mime.startsWith('video/')
        ) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatVideoImg} />;
        }

        if (extension === 'pdf' || mime.includes('pdf')) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatPdfImg} />;
        }

        if (['zip', '7z', 'rar', 'tar', 'gz', 'bz2', 'xz'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={commonZip} />;
        }

        if (['xlsx', 'xls', 'xlsm', 'xlsb', 'xltx', 'csv', 'ods'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatExcelImg} />;
        }

        return <img style={{ width: "90%", height: "90%" }} alt="" src={chatFileImg} />;
    };

    // 관리자 비회원채팅 new 파일업로드
    const nonRenderUploadFilePreview = () => {
        if (!nonSelectedFile) {
            return null;
        }

        const extension = (nonSelectedFile.name || '').split('.').pop()?.toLowerCase();
        const mime = nonSelectedFile.type || '';

        if (
            ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'heic', 'heif', 'svg', 'tiff', 'tif'].includes(extension) ||
            mime.startsWith('image/')
        ) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={nonSelectedFileUrl} />;
        }

        if (
            ['mp4', 'mov', 'avi', 'mkv', 'webm', '3gp', 'm4v', 'mpg', 'mpeg', 'm2v', 'flv', 'swf'].includes(extension) ||
            mime.startsWith('video/')
        ) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatVideoImg} />;
        }

        if (extension === 'pdf' || mime.includes('pdf')) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatPdfImg} />;
        }

        if (['zip', '7z', 'rar', 'tar', 'gz', 'bz2', 'xz'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={commonZip} />;
        }

        if (['xlsx', 'xls', 'xlsm', 'xlsb', 'xltx', 'csv', 'ods'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatExcelImg} />;
        }

        return <img style={{ width: "90%", height: "90%" }} alt="" src={chatFileImg} />;
    };



    // 관리자 주문서수정 렌더링
    const renderModifyFilePreview = () => {
        if (!modifyFile) return null;

        const extension = (modifyFile || '').split('.').pop()?.toLowerCase();
        const mime = ''; // URL 기반으로 type 없음

        if (
            ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'heic', 'heif', 'svg', 'tiff', 'tif'].includes(extension)
        ) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={modifyFile} />;
        }

        if (
            ['mp4', 'mov', 'avi', 'mkv', 'webm', '3gp', 'm4v', 'mpg', 'mpeg', 'm2v', 'flv', 'swf'].includes(extension)
        ) {
            return <video style={{ width: "90%", height: "90%" }} controls src={modifyFile}></video>;
        }

        if (extension === 'pdf') {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatPdfImg} />;
        }

        if (['zip', '7z', 'rar', 'tar', 'gz', 'bz2', 'xz'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={modifyFile} />;
        }

        if (['xlsx', 'xls', 'xlsm', 'xlsb', 'xltx', 'csv', 'ods'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatExcelImg} />;
        }

        return <img style={{ width: "90%", height: "90%" }} alt="" src={chatFileImg} />;
    };

    const fileInputRef = useRef(null);
    const handleFileButtonClick = () => {
        fileInputRef.current.click();
    };


    // 관리자 주문서수정 변경
    const renderChangeFilePreview = () => {
        if (!selectedModifyFile) return null;

        const extension = (selectedModifyFile.name || '').split('.').pop()?.toLowerCase();
        const mime = selectedModifyFile.type || '';

        if (
            ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'heic', 'heif', 'svg', 'tiff', 'tif'].includes(extension) ||
            mime.startsWith('image/')
        ) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={selectedModifyFileUrl} />;
        }

        if (
            ['mp4', 'mov', 'avi', 'mkv', 'webm', '3gp', 'm4v', 'mpg', 'mpeg', 'm2v', 'flv', 'swf'].includes(extension) ||
            mime.startsWith('video/')
        ) {
            return <video style={{ width: "90%", height: "90%" }} alt="" src={chatVideoImg}></video>;
        }

        if (extension === 'pdf' || mime.includes('pdf')) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatPdfImg} />;
        }

        if (['zip', '7z', 'rar', 'tar', 'gz', 'bz2', 'xz'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={commonZip} />;
        }

        if (['xlsx', 'xls', 'xlsm', 'xlsb', 'xltx', 'csv', 'ods'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatExcelImg} />;
        }

        return <img style={{ width: "90%", height: "90%" }} alt="" src={chatFileImg} />;
    };


    // 관리자 비회원수정 렌더링
    const nonRenderModifyFilePreview = () => {
        if (!nonModifyFile) return null;

        const extension = (nonModifyFile || '').split('.').pop()?.toLowerCase();

        if (
            ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'heic', 'heif', 'svg', 'tiff', 'tif'].includes(extension)
        ) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={nonModifyFile} />;
        }

        if (
            ['mp4', 'mov', 'avi', 'mkv', 'webm', '3gp', 'm4v', 'mpg', 'mpeg', 'm2v', 'flv', 'swf'].includes(extension)
        ) {
            return <video style={{ width: "90%", height: "90%" }} controls src={nonModifyFile}></video>;
        }

        if (extension === 'pdf') {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatPdfImg} />;
        }

        if (['zip', '7z', 'rar', 'tar', 'gz', 'bz2', 'xz'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={nonModifyFile} />;
        }

        if (['xlsx', 'xls', 'xlsm', 'xlsb', 'xltx', 'csv', 'ods'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatExcelImg} />;
        }

        return <img style={{ width: "90%", height: "90%" }} alt="" src={chatFileImg} />;
    };

    // 관리자 비회원수정 변경
    const nonRenderChangeFilePreview = () => {
        if (!nonSelectedModifyFile) return null;

        const extension = (nonSelectedModifyFile.name || '').split('.').pop()?.toLowerCase();
        const mime = nonSelectedModifyFile.type || '';

        if (
            ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'heic', 'heif', 'svg', 'tiff', 'tif'].includes(extension) ||
            mime.startsWith('image/')
        ) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={nonSelectedModifyFileUrl} />;
        }

        if (
            ['mp4', 'mov', 'avi', 'mkv', 'webm', '3gp', 'm4v', 'mpg', 'mpeg', 'm2v', 'flv', 'swf'].includes(extension) ||
            mime.startsWith('video/')
        ) {
            return <video style={{ width: "90%", height: "90%" }} alt="" src={chatVideoImg}></video>;
        }

        if (extension === 'pdf' || mime.includes('pdf')) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatPdfImg} />;
        }

        if (['zip', '7z', 'rar', 'tar', 'gz', 'bz2', 'xz'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={commonZip} />;
        }

        if (['xlsx', 'xls', 'xlsm', 'xlsb', 'xltx', 'csv', 'ods'].includes(extension)) {
            return <img style={{ width: "90%", height: "90%" }} alt="" src={chatExcelImg} />;
        }

        return <img style={{ width: "90%", height: "90%" }} alt="" src={chatFileImg} />;
    };


    const [isUploadBtLoading, setIsUploadBtLoading] = useState(false);
    const sendFileSave = ((type) => {
        if (isUploadBtLoading) return;
        setIsUploadBtLoading(true);
        if (type === "adminOrdChatModify") {
            chatFileModify(selectedModifyFile, messageToModify);
        } else if (type === "adminNonChatModify") {
            nonChatFileModify(nonSelectedModifyFile, nonMessageToModify);
        } else if (type === "userNonChatUpload") {
            saveNonChatFile();
        } else {
            saveChatFile();
        }
    })


    return (
        <div data-theme={theme} className="md-scope bookContainer" style={{display:"flex", zIndex:2000}}>
            <div className="bookFrame sqm-chatfile-frame" style={{width:"250px", height:"auto", display:"flex", left:"calc(50vw - 5%)", top:"calc(25vh - -15%)", borderRadius:"5px"}}>
                <div style={{width:"100%", height:"100%"}}>

                    <div style={{height:"40px", display:"flex", alignItems:"center"}}>
                        <div style={{width:"100%", color:"lightgray", textAlign:"right", paddingRight:"5px", position:"relative"}}>
                            <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                <p style={{margin:"0", fontSize:"16px"}}>{(chatFileModifySt || nonChatFileModifySt) ? t('cfuHeader1') : t('cfuHeader2')}</p>
                                <img onClick={chatFileModifySt ? chatFileModifyFalseFn : nonShowChatFile ? nonShowChatFileClose :
                                    nonChatFileModifySt ? nonChatFileModifyFalseFn : showChatFileClose} style={{
                                    width:"25px", height:"25px", opacity:"0.6", position:"absolute", right:"5px", cursor:"pointer"}} alt="close" src={commonClose}/>
                            </div>
                        </div>
                    </div>

                    <div style={{height:"50%", padding:"20px 60px 0 60px"}}>

                        <div style={{height:"60%", maxHeight:"120px", display:"flex", justifyContent:"center", alignItems:"center", overflow:"hidden", borderRadius:"6px", width:"80%", margin:"auto"}}>
                            {renderFilePreview()}
                        </div>

                        <p style={{
                            height: "25%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            textAlign: "center",
                            marginTop: "10px"
                        }}>
                            {/*{nonShowChatFile ? selectedFile && nonSelectedFile.name : selectedFile && selectedFile.name}</p>*/}
                            {/*{chatFileModifySt ? selectedFile && selectedFile.name : nonSelectedFile && nonSelectedFile.name}</p>*/}
                            {/*{nonChatFileModifySt ? nonMessageToModify && nonMessageToModify.fileNm : messageToModify && messageToModify.fileNm}</p>*/}


                            {
                                nonSelectedModifyFile ? nonSelectedModifyFile.name
                                    :
                                    !nonSelectedModifyFile && nonMessageToModify ? nonMessageToModify.fileNm
                                        :
                                        selectedModifyFile ? selectedModifyFile.name
                                            :
                                            nonSelectedFile ? nonSelectedFile.name
                                                :
                                                !selectedModifyFile && messageToModify ? messageToModify.fileNm
                                                    :
                                                    selectedFile ? selectedFile.name
                                                        :
                                                        null
                            }

                        </p>

                    </div>


                    {chatFileModifySt || nonChatFileModifySt ?
                        <div style={{height: "40px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <input type="file" style={{display: "none"}} id="fileInput" ref={fileInputRef} onChange={handleFileChange}/>
                            <label htmlFor="fileInput"/>
                            <button style={{border:"none"}} onClick={handleFileButtonClick}>
                        <span style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                        <img style={{width: "30px", height: "30px", cursor: "pointer"}} src={fileExchange} alt={''}/>
                            </span>
                            </button>

                        </div>
                        :
                        null
                    }


                    <div style={{height: "20%", padding: "12px"}}>
                        <style>
                            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                        </style>
                        {chatFileModifySt ?
                            <button className="orderItemHandleBt user-center" style={{width: "100%", height: "35px", margin: "0"}}
                                    onClick={() => {
                                        sendFileSave("adminOrdChatModify")
                                        // chatFileModify(selectedModifyFile, messageToModify)
                                    }}>
                                {isUploadBtLoading ? (
                                    <div className="spinner"></div>
                                ) : (
                                    <div>{t(`modRegModiBt`)}</div>
                                )}
                            </button>
                            :
                            nonChatFileModifySt ?
                                <button className="orderItemHandleBt user-center"
                                        style={{width: "100%", height: "35px", margin: "0"}}
                                        onClick={() => {
                                            sendFileSave("adminNonChatModify")
                                            // nonChatFileModify(nonSelectedModifyFile, nonMessageToModify)
                                        }}>
                                    {isUploadBtLoading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        <div>{t(`modRegModiBt`)}</div>
                                    )}
                                </button>
                                :
                                nonShowChatFile ?
                                    <button className="orderItemHandleBt user-center"
                                            style={{width: "100%", height: "35px", margin: "0"}}
                                        // onClick={saveNonChatFile}>
                                            onClick={()=> sendFileSave("userNonChatUpload")
                                            }>
                                        {isUploadBtLoading ? (
                                            <div className="spinner"></div>
                                        ) : (
                                            <div>{t(`sendBt`)}</div>
                                        )}
                                    </button>
                                    :
                                    <button className="orderItemHandleBt user-center"
                                            style={{width: "100%", height: "35px", margin: "0"}}
                                        // onClick={saveChatFile}>
                                            onClick={()=> sendFileSave("userOrdChatUpload")
                                            }>
                                        {isUploadBtLoading ? (
                                            <div className="spinner"></div>
                                        ) : (
                                            <div>{t(`sendBt`)}</div>
                                        )}
                                    </button>
                        }
                    </div>

                </div>
            </div>


            {
                fileSizeOverSt ?
                    <MsgCheckModal fileSizeOverSt={fileSizeOverSt} closeFileSizeOverSt={closeFileSizeOverSt}/>
                    :
                    null
            }

        </div>
    )
}

export default ChatFileUpload
